import './index.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { Helmet } from 'react-helmet';
import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { ThemeProvider } from './context/ThemeContext';

// Auth
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';

// Pages
import Dashboard from './pages/Dashboard';
import SendSMS from './pages/SendSMS';
import AddBalance from './pages/AddBalance';
import CreateToken from './pages/CreateToken';
import DevDocs from './pages/api/docs';
import SMSHistory from './pages/History';
import Rules from './pages/Terms';
import Profile from './pages/Profile';

// Components
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import AuthProvider from './context/AuthContext';

function App() {
  // Configure NProgress
  NProgress.configure({ showSpinner: true });

  return (
    <HelmetProvider>
      <AuthProvider>
        <ThemeProvider>
          <Router>
            <Helmet>
              <meta name="description" content="SMS ugratmak hyzmaty" />
            </Helmet>

            <ToastContainer position="bottom-right" autoClose={3000} />

            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />

              <Route path="/" element={
                <PrivateRoute>
                  <Layout />
                </PrivateRoute>
              }>
                <Route index element={<Dashboard />} />
                <Route path="send-sms" element={<SendSMS />} />
                <Route path="add-balance" element={<AddBalance />} />
                <Route path="create-token" element={<CreateToken />} />
                <Route path="dev-docs" element={<DevDocs />} />
                <Route path="sms-history" element={<SMSHistory />} />
                <Route path="rules" element={<Rules />} />
                <Route path="profile" element={<Profile />} />
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Router>
        </ThemeProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;